export enum LegalMentionsType {
  LatePaymentPenaltyRate = 'latePaymentPenaltyRate',
  EarlyPaymentDiscount = 'earlyPaymentDiscount',
}
